



























import Vue from 'vue';
import { getContentArea } from '@/contentful';

interface Data {
  isLoading: boolean;
  title: string;
  content: string;
  error: boolean;
}

export default Vue.extend({
  name: 'InformationPage',
  props: {
    contentArea: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: true,
      title: '',
      content: '',
      error: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.getContent();
      }
    },
  },
  mounted() {
    this.getContent();
  },
  methods: {
    getContent(): void {
      this.isLoading = true;
      getContentArea(this.contentArea)
        .then((data) => {
          if (data) {
            this.title = data.fields.title;
            this.content = data.fields.content;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
});
